<template>
  <CCard>
    <CCardHeader class="d-flex justify-content-between align-items-center">
      سوالات
      <CButton
        :disabled="loading"
        color="primary"
        class="px-sm-5 py-sm-2"
        @click="onShowQuestion"
      >
        <CIcon name="cil-plus" />
        افزودن سوال
      </CButton>
    </CCardHeader>
    <CCardBody class="d-flex align-items-center text-center h-100">
      <CDataTable
        class="w-100 d-flex justify-content-between h-100"
        :noItemsView="{
          noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
        }"
        :items="questions"
        :fields="fields"
        hover
        striped
        border
        small
        fixed
        :loading="loading"
      >
        <template #editQuestion="{ item }">
          <td>
            <CButton square size="sm" @click="onEditQuestionCard(item)">
              <CIcon name="cil-pen" />
            </CButton>
          </td>
        </template>
        <template #text="{ item }">
          <td>
            <div v-if="item.text.length > 30">
              {{ item.text.slice(0, 30) }}...
            </div>
            <div v-else>{{ item.text }}</div>
          </td>
        </template>
        <template #removeQuestion="{ item }">
          <td>
            <CButton
              :disabled="loading"
              size="sm"
              @click="onRemoveQuestionModal(item)"
            >
              <CIcon name="cil-trash" />
            </CButton>
          </td>
        </template>
      </CDataTable>

      <RemoveQuestionModal
        v-model="questionRemoveModal"
        :question="selectedItem"
        @get-questions="getQuestions"
      />
    </CCardBody>
  </CCard>
</template>

<script>
import RemoveQuestionModal from "../Modals/Exam/RemoveQuestionModal.vue";

export default {
  components: {
    RemoveQuestionModal,
  },
  name: "QuestionsTable",
  props: {
    questions: {
      type: Array,
    },
  },

  data() {
    return {
      loading: false,
      fields: [
        {
          key: "text",
          label: "تیتر سوال",
        },
        { key: "editQuestion", label: "ویرایش" },
        { key: "mark", label: "بارم" },
        { key: "removeQuestion", label: "حذف" },
      ],
      questionRemoveModal: false,
      questionViewModal: false,
      selectedItem: {},
    };
  },
  methods: {
    onEditQuestionCard(item) {
      this.$emit("edit-question", item);
    },
    onRemoveQuestionModal(item) {
      this.selectedItem = item;
      this.questionRemoveModal = true;
    },
    onViewQuestionModal(item) {
      this.selectedItem = item;
      this.questionViewModal = true;
    },
    getQuestions() {
      this.$emit("get-questions");
    },
    onShowQuestion() {
      this.$emit("show-question", true);
    },
  },
};
</script>

<style lang="scss" scoped></style>